import { HStack, Text } from "@chakra-ui/react";
import { FeedCardIcon } from "src/components/feed-card/content-blocks/icon/feed-card-icon";
import { IFeedCardIconTextBody } from "src/components/feed-card/types/content";

export const FeedCardIconText = ({ icon, text }: IFeedCardIconTextBody) => (
    <HStack spacing={2}>
        <FeedCardIcon icon={icon} width={9} height="auto" />
        <Text>{text}</Text>
    </HStack>
);
